import { stateName } from './constants';

const localState = state => state[stateName];

export const getCaptchaUuid = state => localState(state).captchaUuid;
export const getFailedFilenames = state => localState(state).failedFilenames;
export const getSavedFiles = state => localState(state).savedFiles;
export const getUploadUiState = state => localState(state).uploadUiState;
export const getFilesToRetry = state => localState(state).filesToRetry;
export const getFormData = state => localState(state).formData;
export const getFormUiState = state => localState(state).formUiState;
export const getFieldErrors = state => localState(state).fieldErrors;